import { createReducer, on } from '@ngrx/store';

export const initialState = null;
import { account, guest, edit, editAccount, serviceDrive, serviceDriveAbandonedCart, sdLogout, subscriptions, employee } from '../_actions/app-flow-state.actions';


const _appFlowStateReducer = createReducer(initialState,
    on(account, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'account')
        return 'account';
    }),
    on(guest, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'guest')
        return 'guest';
    }),
    on(edit, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'edit')
        return 'edit';
    }),
    on(editAccount, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'editAccount')
        return 'editAccount';
    }),
    on(serviceDrive, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'serviceDrive')
        return 'serviceDrive';
    }),
    on(serviceDriveAbandonedCart, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'serviceDrive Abandoned Cart')
        return 'serviceDriveAbandonedCart';
    }),
    on(sdLogout, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'SDLogout')
        return 'SDLogout';
    }),
    on(subscriptions, (state, payload) => {
        sessionStorage.setItem('appFlowState', 'subscriptions')
        return 'subscriptions';
    }),
    on(employee, () => {
        sessionStorage.setItem('appFlowState', 'employee')
        return 'employee';
    })
); 


export function appFlowStateReducer(state, action) {
    return _appFlowStateReducer(state, action);
}
